/**
 * Vehicle actions
 */
export enum VehicleActionEnum {
	/**
	 * Set vehicle status to "In Park"
	 */
	PARK = 'park',

	/**
	 * Set vehicle status to "Out of Service"
	 */
	OUT_OF_SERVICE = 'out_of_service',

	/**
	 * Update the vehicle's odometer value
	 */
	UPDATE_ODOMETER = 'update_odometer',

	/**
	 * Set vehicle status to hard hold
	 */
	HARD_HOLD = 'hard_hold',

	/**
	 * Mark the vehicle as sold
	 */
	SELL = 'sell',
}
